var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from './baseApi';
import { BatchProcessStatus, } from '@onereach/types-contacts-api';
export default class BatchProcessApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'batch-process';
    }
    getBatchProcess(id) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}/${id}`,
        });
    }
    trackBatchProcess(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const batchProcess = yield this.getBatchProcess(id);
            let result = {
                status: batchProcess.status,
            };
            if (batchProcess.status === BatchProcessStatus.success) {
                result = Object.assign(Object.assign({}, result), { contactsIds: batchProcess.results.flatMap(i => JSON.parse(i)) });
            }
            if (batchProcess.status === BatchProcessStatus.failed) {
                result = Object.assign(Object.assign({}, result), { errors: batchProcess.messages, contactsIds: batchProcess.results.flatMap(i => JSON.parse(i)) });
            }
            return result;
        });
    }
    getBatchProcessesGroup(groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/group/${groupId}`,
            });
        });
    }
}
//# sourceMappingURL=batchProcessApi.js.map